import { isPasswordComponent } from './isPasswordComponents';

export const prepareGoogleRegistrationForm = form => {
  const transformedFieldsForm = transformRegistrationForm(form);
  const finalGoogleAuthForm = filterGoogleOAuthFields(transformedFieldsForm);

  return finalGoogleAuthForm;
};

const transformRegistrationForm = form => ({
  ...form,
  steps: form.steps.map(step => ({
    ...step,
    fields: step.fields.map(field => ({
      ...field,
      isModifiable: field.editable,
      maskOptions: field.maskOptions || (field.maskOption ? [field.maskOption] : []),
      options: field.options || [],
      rules: field.rules || [],
      selectableFields: field.selectableFields || [],
    })),
  })),
});

const filterGoogleOAuthFields = form => ({
  ...form,
  steps: form.steps.map(step => ({
    ...step,
    fields: hideGooglePasswordFields(step.fields),
  })),
});

const hideGooglePasswordFields = fields => {
  return fields.map(field => {
    if (isPasswordComponent(field)) {
      return {
        ...field,
        hidden: true,
        rules: [],
      };
    }

    return { ...field };
  });
};
